import { useEffect, useState } from "react";
import { PageHeader, Panel } from "../components/Surface";
import { Icon } from "../app/Icon";
import { networkFeed, verbIcon, type Activity } from "../lib/activity";

export function Feed() {
  const [items, setItems] = useState<Activity[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    networkFeed().then((r) => setItems(r.activities)).catch(() => undefined).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto grid w-full max-w-2xl gap-6">
      <PageHeader title="Activity" subtitle="What your network is doing on RecruitTrucker." />
      <Panel>
        {loading ? (
          <p className="font-mono text-sm text-muted">Loading…</p>
        ) : items.length === 0 ? (
          <p className="text-sm text-muted">No activity yet. Connect with members to see their updates here.</p>
        ) : (
          <ul className="grid gap-3">
            {items.map((a) => (
              <li key={a.id} className="flex items-center gap-3">
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-surface-2 text-muted">
                  <Icon name={verbIcon(a.verb)} className="h-4 w-4" />
                </span>
                <span className="min-w-0 text-sm">
                  <span className="font-bold">{a.actor_name ?? "A member"}</span>{" "}
                  <span className="text-muted">{a.summary ?? a.verb.replace(/_/g, " ")}</span>
                  <span className="block font-mono text-[10px] text-muted">{new Date(a.created_at).toLocaleString()}</span>
                </span>
              </li>
            ))}
          </ul>
        )}
      </Panel>
    </div>
  );
}
